import { useSelector } from "react-redux";
import { userPermissions } from "../store/reducers/user";

const useHaveUserPermission = (perm, type) => {
  const permissions = useSelector(userPermissions);
  return permissions[perm] ? permissions[perm].includes(type) : false;
};

export default useHaveUserPermission;
